import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, ButtonBar } from '@frontend/design-system';

type Props = {
  disableNext?: boolean;
  disablePrevious?: boolean;
  onNextClick?: () => void;
  onPreviousClick?: () => void;
  trackingIdBase?: string;
};

export const NavigationButtons = ({
  disableNext,
  disablePrevious,
  trackingIdBase,
  onNextClick,
  onPreviousClick,
}: Props) => {
  const { t } = useTranslation('call-insight-panel');

  return (
    <ButtonBar css={styles.wrapper}>
      <Button
        disabled={disablePrevious}
        onClick={onPreviousClick}
        style={disablePrevious ? { color: theme.colors.neutral40 } : undefined}
        variant='secondary'
        trackingId={`${trackingIdBase}-previous-button`}
      >
        {t('Previous')}
      </Button>
      <Button
        disabled={disableNext}
        onClick={onNextClick}
        style={disableNext ? { color: theme.colors.neutral40 } : undefined}
        variant='secondary'
        trackingId={`${trackingIdBase}-previous-next`}
      >
        {t('Next')}
      </Button>
    </ButtonBar>
  );
};

const styles = {
  wrapper: css`
    width: auto;
    padding: 0;
    > button {
      width: auto;
      height: ${theme.spacing(5)};
    }
  `,
};
